import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, normalizeStyle as _normalizeStyle, vShow as _vShow, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "portal-page__inner" }
const _hoisted_2 = { class: "info-plaza__head" }
const _hoisted_3 = { class: "info-plaza__head-actions" }
const _hoisted_4 = ["aria-pressed"]
const _hoisted_5 = ["aria-label", "title"]
const _hoisted_6 = {
  key: 0,
  class: "staff-note"
}
const _hoisted_7 = { class: "info-plaza__layout" }
const _hoisted_8 = {
  key: 0,
  class: "info-plaza__side-actions"
}
const _hoisted_9 = {
  type: "submit",
  class: "portal-btn portal-btn--primary",
  "aria-label": "검색"
}
const _hoisted_10 = {
  key: 0,
  class: "info-plaza__status"
}
const _hoisted_11 = {
  key: 1,
  class: "info-plaza__status"
}
const _hoisted_12 = { class: "info-tree__name" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "info-tree__name" }
const _hoisted_15 = {
  key: 0,
  class: "info-tree__tag"
}
const _hoisted_16 = {
  key: 0,
  class: "info-plaza__status"
}
const _hoisted_17 = {
  key: 0,
  class: "info-tree__row",
  style: {"--depth":"1"}
}
const _hoisted_18 = { class: "info-tree__item" }
const _hoisted_19 = ["draggable", "onDragstart", "onDragover", "onDragleave", "onDrop", "onContextmenu"]
const _hoisted_20 = ["aria-label", "onClick"]
const _hoisted_21 = {
  key: 1,
  class: "info-tree__toggle-spacer"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "info-tree__name" }
const _hoisted_24 = {
  key: 0,
  class: "staff-badge"
}
const _hoisted_25 = ["draggable", "onDragstart", "onContextmenu"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 1,
  class: "info-tree__name"
}
const _hoisted_28 = {
  key: 0,
  class: "staff-badge"
}
const _hoisted_29 = {
  key: 1,
  class: "info-plaza__status"
}
const _hoisted_30 = {
  key: 1,
  class: "fx-hint"
}
const _hoisted_31 = {
  key: 2,
  class: "fx-hint"
}
const _hoisted_32 = { class: "info-plaza__reader" }
const _hoisted_33 = { class: "info-reader__head" }
const _hoisted_34 = { class: "info-reader__title" }
const _hoisted_35 = {
  key: 0,
  class: "fx-viewer__folder"
}
const _hoisted_36 = {
  key: 0,
  class: "fx-viewer__tabs",
  role: "tablist"
}
const _hoisted_37 = ["aria-selected"]
const _hoisted_38 = ["aria-selected"]
const _hoisted_39 = { class: "info-reader__body" }
const _hoisted_40 = ["srcdoc", "title"]
const _hoisted_41 = {
  key: 0,
  class: "fx-viewer__edit"
}
const _hoisted_42 = { class: "fx-viewer__field" }
const _hoisted_43 = { class: "fx-viewer__field fx-viewer__field--grow" }
const _hoisted_44 = { class: "fx-viewer__field fx-viewer__field--row" }
const _hoisted_45 = {
  key: 0,
  class: "staff-editor__error"
}
const _hoisted_46 = {
  key: 0,
  class: "info-reader__foot"
}
const _hoisted_47 = ["disabled"]
const _hoisted_48 = ["aria-label"]
const _hoisted_49 = { class: "info-cards__head" }
const _hoisted_50 = {
  key: 0,
  class: "info-cards__grid"
}
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "info-card__thumb" }
const _hoisted_53 = ["src"]
const _hoisted_54 = ["srcdoc"]
const _hoisted_55 = { class: "info-card__meta" }
const _hoisted_56 = { class: "info-card__title" }
const _hoisted_57 = {
  key: 0,
  class: "info-card__summary"
}
const _hoisted_58 = {
  key: 1,
  class: "info-reader__empty"
}
const _hoisted_59 = { role: "none" }
const _hoisted_60 = {
  key: 0,
  role: "none"
}
const _hoisted_61 = { role: "none" }
const _hoisted_62 = {
  key: 1,
  role: "none"
}
const _hoisted_63 = { role: "none" }

import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AppIcon from '@/components/common/AppIcon.vue'
import { useAdminAuth } from '@/composables/useAdminAuth'
import { useInfoTheme } from '@/composables/useInfoTheme'
import { confirmDialog } from '@/composables/useConfirmDialog'
import {
  fetchAdminInfo,
  fetchPublicInfo,
  fetchPublicInfoDoc,
  moveInfoDoc,
  moveInfoFolder,
  removeInfoDoc,
  removeInfoFolder,
  saveInfoDoc,
  saveInfoFolder,
  type InfoDoc,
  type InfoFolder,
  type InfoStatus,
} from '@/api/infoPlaza'

type Selection = { kind: 'folder' | 'doc'; idx: number }
type TreeRow =
  | { kind: 'folder'; idx: number; name: string; status: InfoStatus; depth: number; hasChildren: boolean; count: number }
  | { kind: 'doc'; doc: InfoDoc; depth: number }


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoPlazaPage',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const { isAdminLoggedIn, initAdminAuth } = useAdminAuth()
const { theme, toggleTheme } = useInfoTheme()

/* 변경모드 — 관리자가 켰을 때만 편집 가능 */
const editMode = ref(false)
const canEdit = computed(() => isAdminLoggedIn.value && editMode.value)

const folders = ref<InfoFolder[]>([])
const docs = ref<InfoDoc[]>([])
const keyword = ref('')
const appliedKeyword = ref('')
const loading = ref(false)
const errorMessage = ref('')
const staffNote = ref('')
const expanded = ref<Set<number>>(new Set())

const creatingFolder = ref(false)
const newFolderName = ref('')
const newFolderBox = ref<HTMLInputElement | null>(null)
const createParent = ref<number | null>(null)

const menu = ref<{ x: number; y: number; target: Selection | null } | null>(null)

const selected = ref<Selection | null>(null)
const renaming = ref<Selection | null>(null)
const renameText = ref('')
const renameBox = ref<HTMLInputElement[] | HTMLInputElement | null>(null)

const uploadInput = ref<HTMLInputElement | null>(null)

const viewer = ref<InfoDoc | null>(null)
const viewerTab = ref<'view' | 'edit'>('view')
const editDraft = ref<{ title: string; content: string; status: InfoStatus }>({
  title: '',
  content: '',
  status: 'PUBLISHED',
})
const savingEdit = ref(false)
const editError = ref('')

const dragInfo = ref<Selection | null>(null)
const dropTarget = ref<number | 'root' | null>(null)

const activeFolder = computed(() => {
  const value = Number(route.query.folder)
  return Number.isFinite(value) && value > 0 ? value : 0
})

const isSearching = computed(() => Boolean(appliedKeyword.value))

const childrenOf = computed(() => {
  const map = new Map<number | null, InfoFolder[]>()
  for (const folder of folders.value) {
    const key = folder.parentIdx ?? null
    const list = map.get(key)
    if (list) list.push(folder)
    else map.set(key, [folder])
  }
  for (const list of map.values()) list.sort((a, b) => a.sort - b.sort || a.idx - b.idx)
  return map
})

const docsByFolder = computed(() => {
  const map = new Map<number, InfoDoc[]>()
  for (const doc of docs.value) {
    const list = map.get(doc.folderIdx)
    if (list) list.push(doc)
    else map.set(doc.folderIdx, [doc])
  }
  for (const list of map.values())
    list.sort((a, b) => a.sort - b.sort || b.createdAt.localeCompare(a.createdAt))
  return map
})

function descendantFolderIds(idx: number): number[] {
  const children = folders.value.filter((folder) => folder.parentIdx === idx)
  return [idx, ...children.flatMap((folder) => descendantFolderIds(folder.idx))]
}

function countInFolder(idx: number) {
  const ids = new Set(descendantFolderIds(idx))
  return docs.value.filter((doc) => ids.has(doc.folderIdx)).length
}

/* 폴더 + (펼쳐지면) 하위 폴더·파일을 한 줄씩 평면화 */
const treeRows = computed<TreeRow[]>(() => {
  const rows: TreeRow[] = []
  const walk = (parent: number | null, depth: number) => {
    for (const folder of childrenOf.value.get(parent) ?? []) {
      const subfolders = childrenOf.value.get(folder.idx) ?? []
      const docsHere = docsByFolder.value.get(folder.idx) ?? []
      rows.push({
        kind: 'folder',
        idx: folder.idx,
        name: folder.name,
        status: folder.status,
        depth,
        hasChildren: subfolders.length > 0 || docsHere.length > 0,
        count: countInFolder(folder.idx),
      })
      if (expanded.value.has(folder.idx)) {
        walk(folder.idx, depth + 1)
        for (const doc of docsHere) rows.push({ kind: 'doc', doc, depth: depth + 1 })
      }
    }
  }
  walk(null, 0)
  return rows
})

/* 검색 결과(문서 평면 목록) */
const visibleDocs = computed(() =>
  [...docs.value].sort((a, b) => a.sort - b.sort || b.createdAt.localeCompare(a.createdAt)),
)

/* 가운데 썸네일 그리드: 전체는 모든 글, 폴더는 그 폴더와 하위 글 */
const gridDocs = computed(() => {
  if (isSearching.value) return visibleDocs.value
  const folderIdx = selected.value?.kind === 'folder' ? selected.value.idx : 0
  if (!folderIdx) return visibleDocs.value
  const ids = new Set(descendantFolderIds(folderIdx))
  return visibleDocs.value.filter((doc) => ids.has(doc.folderIdx))
})

const gridTitle = computed(() => {
  if (isSearching.value) return `'${appliedKeyword.value}' 검색`
  if (selected.value?.kind === 'folder') {
    return folders.value.find((folder) => folder.idx === selected.value?.idx)?.name || '폴더'
  }
  return '전체'
})

const htmlCache = ref<Record<string, string>>({})

function htmlOf(doc: InfoDoc) {
  return doc.content ?? htmlCache.value[doc.id] ?? ''
}

function thumbImage(doc: InfoDoc) {
  const html = htmlOf(doc)
  const match = html.match(/<img\b[^>]*\ssrc=["']([^"']+)["']/i)
  const src = match?.[1]?.trim() || ''
  if (!src || /^javascript:/i.test(src) || src.startsWith('data:text')) return ''
  return src
}

let thumbToken = 0
watch(gridDocs, (list) => {
  const token = ++thumbToken
  const missing = list.filter((doc) => doc.content == null && htmlCache.value[doc.id] == null)
  if (!missing.length) return
  void Promise.all(
    missing.map(async (doc) => {
      try {
        const full = await fetchPublicInfoDoc(doc.id)
        if (token !== thumbToken) return
        htmlCache.value = { ...htmlCache.value, [doc.id]: full.content || '' }
      } catch {
        /* 썸네일만 비운다 */
      }
    }),
  )
})

function toggleEditMode() {
  editMode.value = !editMode.value
}

/* 변경모드를 끄면 진행 중이던 편집 UI를 모두 정리한다 */
watch(editMode, (on) => {
  if (on) return
  cancelRename()
  cancelCreateFolder()
  closeMenu()
  if (viewerTab.value === 'edit') viewerTab.value = 'view'
})

function toggleFolder(idx: number) {
  const next = new Set(expanded.value)
  if (next.has(idx)) next.delete(idx)
  else next.add(idx)
  expanded.value = next
}

function expandAncestors(idx: number) {
  const next = new Set(expanded.value)
  let current = folders.value.find((folder) => folder.idx === idx)
  let guard = 0
  while (current && guard < 20) {
    next.add(current.idx)
    guard += 1
    current = folders.value.find((folder) => folder.idx === current?.parentIdx)
  }
  expanded.value = next
}

async function setFolderQuery(idx: number) {
  const query = { ...route.query }
  if (idx) query.folder = String(idx)
  else delete query.folder
  await router.replace({ path: '/info/library', query }).catch(() => {})
}

async function clearSearchIfAny() {
  if (!appliedKeyword.value) return
  keyword.value = ''
  appliedKeyword.value = ''
  await load({ silent: true })
}

/* "전체" 루트 또는 메뉴에서 폴더 선택 — 가운데는 썸네일 그리드 */
async function selectFolder(idx: number) {
  viewer.value = null
  selected.value = idx ? { kind: 'folder', idx } : null
  await setFolderQuery(idx)
  if (idx) expandAncestors(idx)
  await clearSearchIfAny()
}

/* 트리에서 폴더 이름 클릭: 이미 열린 폴더는 유지한 채 이 폴더만 펼친다 */
async function onFolderClick(idx: number) {
  viewer.value = null
  const next = new Set(expanded.value)
  next.add(idx)
  expanded.value = next
  selected.value = { kind: 'folder', idx }
  await clearSearchIfAny()
  await setFolderQuery(idx)
}

async function runSearch() {
  viewer.value = null
  appliedKeyword.value = keyword.value.trim()
  selected.value = null
  await load()
}

async function load(opts: { silent?: boolean } = {}) {
  if (!opts.silent) loading.value = true
  errorMessage.value = ''
  try {
    await initAdminAuth()
    const data = isAdminLoggedIn.value
      ? await fetchAdminInfo(appliedKeyword.value)
      : await fetchPublicInfo({ keyword: appliedKeyword.value })
    folders.value = data.folders
    docs.value = data.docs
    const open = new Set(expanded.value)
    for (const folder of data.folders) {
      if (data.folders.some((item) => item.parentIdx === folder.idx)) open.add(folder.idx)
    }
    expanded.value = open
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '정보마당을 불러오지 못했습니다.'
  } finally {
    loading.value = false
  }
}

/* ---------- 인라인 새 폴더 ---------- */
async function beginCreateFolder(parentOverride?: number | null) {
  closeMenu()
  const parent = parentOverride !== undefined ? parentOverride : activeFolder.value || null
  if (isSearching.value) await selectFolder(parent || 0)
  if (parent) expandAncestors(parent)
  createParent.value = parent
  newFolderName.value = '새 폴더'
  creatingFolder.value = true
  await nextTick()
  newFolderBox.value?.focus()
  newFolderBox.value?.select()
}

function cancelCreateFolder() {
  creatingFolder.value = false
  newFolderName.value = ''
}

async function commitCreateFolder() {
  if (!creatingFolder.value) return
  const name = newFolderName.value.trim()
  creatingFolder.value = false
  if (!name) {
    newFolderName.value = ''
    return
  }
  try {
    const parentIdx = createParent.value
    const siblings = childrenOf.value.get(parentIdx) ?? []
    const sort = siblings.reduce((max, f) => Math.max(max, f.sort), 0) + 1
    await saveInfoFolder({ name, parentIdx, status: 'PUBLISHED', sort })
    staffNote.value = '폴더를 만들었습니다.'
    await load({ silent: true })
  } catch (error) {
    staffNote.value = error instanceof Error ? error.message : '폴더 생성에 실패했습니다.'
  } finally {
    newFolderName.value = ''
  }
}

/* ---------- 삭제 ---------- */
async function removeSelected() {
  if (!selected.value) return
  if (selected.value.kind === 'folder') {
    const folder = folders.value.find((f) => f.idx === selected.value?.idx)
    if (folder) await removeFolderItem(folder)
  } else {
    const doc = docs.value.find((d) => d.idx === selected.value?.idx)
    if (doc) await removeDoc(doc)
  }
}

async function removeDoc(doc: InfoDoc) {
  if (!doc.idx) return
  const ok = await confirmDialog({
    title: '파일 삭제',
    message: '이 HTML 파일을 삭제할까요? 삭제 후 복구할 수 없습니다.',
    detail: doc.title,
    confirmLabel: '삭제',
    tone: 'danger',
  })
  if (!ok) return
  try {
    await removeInfoDoc(doc.idx)
    if (viewer.value?.idx === doc.idx) viewer.value = null
    selected.value = null
    staffNote.value = '파일을 삭제했습니다.'
    await load({ silent: true })
  } catch (error) {
    staffNote.value = error instanceof Error ? error.message : '삭제에 실패했습니다.'
  }
}

async function removeFolderItem(folder: InfoFolder) {
  const ok = await confirmDialog({
    title: '폴더 삭제',
    message: '이 폴더를 삭제할까요? 폴더 안에 파일이나 하위 폴더가 있으면 삭제되지 않습니다.',
    detail: folder.name,
    confirmLabel: '삭제',
    tone: 'danger',
  })
  if (!ok) return
  try {
    await removeInfoFolder(folder.idx)
    selected.value = null
    staffNote.value = '폴더를 삭제했습니다.'
    await load({ silent: true })
  } catch (error) {
    staffNote.value = error instanceof Error ? error.message : '폴더 삭제에 실패했습니다.'
  }
}

/* ---------- 이름 변경(인라인) ---------- */
function isRenamingId(kind: 'folder' | 'doc', idx: number) {
  return renaming.value?.kind === kind && renaming.value.idx === idx
}

async function startRename(sel: Selection) {
  if (sel.kind === 'folder') {
    renameText.value = folders.value.find((f) => f.idx === sel.idx)?.name || ''
  } else {
    renameText.value = docs.value.find((d) => d.idx === sel.idx)?.title || ''
  }
  renaming.value = { ...sel }
  await nextTick()
  const box = Array.isArray(renameBox.value) ? renameBox.value[0] : renameBox.value
  box?.focus()
  box?.select()
}

function cancelRename() {
  renaming.value = null
  renameText.value = ''
}

async function commitRename() {
  const target = renaming.value
  if (!target) return
  const name = renameText.value.trim()
  renaming.value = null
  if (!name) return
  try {
    if (target.kind === 'folder') {
      const folder = folders.value.find((f) => f.idx === target.idx)
      if (!folder || folder.name === name) return
      await saveInfoFolder({ name, parentIdx: folder.parentIdx, status: folder.status, sort: folder.sort }, folder.idx)
      staffNote.value = '폴더 이름을 바꿨습니다.'
    } else {
      const doc = docs.value.find((d) => d.idx === target.idx)
      if (!doc || !doc.idx || doc.title === name) return
      await saveInfoDoc(
        {
          title: name,
          folderIdx: doc.folderIdx,
          content: doc.content ?? '',
          summary: doc.summary,
          status: doc.status,
          sort: doc.sort,
        },
        doc.idx,
      )
      if (viewer.value?.idx === doc.idx) viewer.value = { ...viewer.value, title: name }
      staffNote.value = '파일 이름을 바꿨습니다.'
    }
    await load({ silent: true })
  } catch (error) {
    staffNote.value = error instanceof Error ? error.message : '이름 변경에 실패했습니다.'
  }
}

/* ---------- HTML 업로드 ---------- */
function triggerUpload() {
  closeMenu()
  if (!folders.value.length) {
    staffNote.value = 'HTML을 올리려면 폴더가 먼저 필요합니다. 「새 폴더」로 만들어 주세요.'
    return
  }
  uploadInput.value?.click()
}

function readFile(file: File) {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(String(reader.result || ''))
    reader.onerror = () => reject(new Error(`${file.name} 을(를) 읽지 못했습니다.`))
    reader.readAsText(file, 'utf-8')
  })
}

async function onUploadChange(event: Event) {
  const input = event.target as HTMLInputElement
  const files = Array.from(input.files || [])
  input.value = ''
  if (!files.length) return
  const folderIdx = activeFolder.value || folders.value[0]?.idx
  if (!folderIdx) {
    staffNote.value = 'HTML을 올릴 폴더를 먼저 선택해 주세요.'
    return
  }
  let done = 0
  for (const file of files) {
    const isHtml = /\.(html?|htm)$/i.test(file.name) || file.type === 'text/html'
    if (!isHtml) {
      staffNote.value = 'HTML 파일(.html)만 올릴 수 있습니다.'
      continue
    }
    try {
      const content = await readFile(file)
      const title = file.name.replace(/\.(html?|htm)$/i, '').trim() || 'HTML 문서'
      await saveInfoDoc({ title, folderIdx, content, status: 'PUBLISHED' })
      done += 1
    } catch (error) {
      staffNote.value = error instanceof Error ? error.message : '업로드에 실패했습니다.'
    }
  }
  if (done) {
    expandAncestors(folderIdx)
    staffNote.value = `HTML ${done}개를 올렸습니다.`
    await load({ silent: true })
  }
}

/* ---------- 파일 열기(중앙 리더) ---------- */
async function openDoc(doc: InfoDoc) {
  selected.value = doc.idx ? { kind: 'doc', idx: doc.idx } : null
  viewerTab.value = 'view'
  editError.value = ''
  let content = doc.content
  if (content == null) {
    try {
      const full = await fetchPublicInfoDoc(doc.id)
      content = full.content ?? ''
    } catch {
      content = ''
    }
  }
  const resolved: InfoDoc = { ...doc, content: content ?? '' }
  viewer.value = resolved
  editDraft.value = {
    title: resolved.title,
    content: resolved.content ?? '',
    status: resolved.status === 'HIDDEN' ? 'HIDDEN' : 'PUBLISHED',
  }
}

function frameSrcdoc(html: string) {
  const content = html || ''
  if (/<\s*(!doctype|html)\b/i.test(content)) return content
  return `<!DOCTYPE html><html lang="ko"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"><style>:root{color-scheme:light}body{margin:0;padding:24px;font-family:'Noto Sans KR','Apple SD Gothic Neo',system-ui,sans-serif;line-height:1.85;color:#1b1f27;word-break:keep-all}img{max-width:100%;height:auto}table{border-collapse:collapse}</style></head><body>${content}</body></html>`
}

async function saveEdit() {
  const current = viewer.value
  if (!current?.idx || savingEdit.value) return
  const title = editDraft.value.title.trim()
  const content = editDraft.value.content
  if (!title) {
    editError.value = '제목을 입력해 주세요.'
    return
  }
  if (!content.trim()) {
    editError.value = 'HTML 내용을 입력해 주세요.'
    return
  }
  savingEdit.value = true
  editError.value = ''
  try {
    const saved = await saveInfoDoc(
      { title, folderIdx: current.folderIdx, content, status: editDraft.value.status, sort: current.sort },
      current.idx,
    )
    viewer.value = { ...saved, content }
    editDraft.value.title = saved.title
    editDraft.value.status = saved.status === 'HIDDEN' ? 'HIDDEN' : 'PUBLISHED'
    viewerTab.value = 'view'
    staffNote.value = '파일을 저장했습니다.'
    await load({ silent: true })
  } catch (error) {
    editError.value = error instanceof Error ? error.message : '저장에 실패했습니다.'
  } finally {
    savingEdit.value = false
  }
}

/* ---------- 드래그 이동 ---------- */
function onDragStart(kind: 'folder' | 'doc', idx: number, event: DragEvent) {
  if (!canEdit.value || !idx) return
  closeMenu()
  selected.value = { kind, idx }
  dragInfo.value = { kind, idx }
  document.body.classList.add('fx-is-dragging')
  if (event.dataTransfer) {
    event.dataTransfer.effectAllowed = 'move'
    event.dataTransfer.setData('text/plain', `${kind}:${idx}`)
  }
}

function onDragEnd() {
  dragInfo.value = null
  dropTarget.value = null
  document.body.classList.remove('fx-is-dragging')
}

function canDropOn(target: number | 'root'): boolean {
  const d = dragInfo.value
  if (!d) return false
  if (target === 'root') return d.kind === 'folder'
  if (d.kind === 'doc') return true
  if (d.idx === target) return false
  return !descendantFolderIds(d.idx).includes(target)
}

function onDragOverTarget(target: number | 'root', event: DragEvent) {
  if (!dragInfo.value || !canDropOn(target)) return
  event.preventDefault()
  if (event.dataTransfer) event.dataTransfer.dropEffect = 'move'
  dropTarget.value = target
}

function onDragLeaveTarget(target: number | 'root') {
  if (dropTarget.value === target) dropTarget.value = null
}

async function onDropTarget(target: number | 'root') {
  const d = dragInfo.value
  dropTarget.value = null
  dragInfo.value = null
  if (!d || !canDropOn(target)) return
  try {
    if (d.kind === 'doc') {
      if (target === 'root') {
        staffNote.value = '파일은 폴더 안으로만 옮길 수 있습니다.'
        return
      }
      const doc = docs.value.find((item) => item.idx === d.idx)
      if (doc?.folderIdx === target) return
      await moveInfoDoc(d.idx, target)
      expandAncestors(target)
      staffNote.value = '파일을 옮겼습니다.'
    } else {
      const parentIdx = target === 'root' ? null : target
      const folder = folders.value.find((item) => item.idx === d.idx)
      if ((folder?.parentIdx ?? null) === parentIdx) return
      await moveInfoFolder(d.idx, parentIdx)
      if (parentIdx) expandAncestors(parentIdx)
      staffNote.value = '폴더를 옮겼습니다.'
    }
    await load({ silent: true })
  } catch (error) {
    staffNote.value = error instanceof Error ? error.message : '이동에 실패했습니다.'
  }
}

/* ---------- 우클릭 컨텍스트 메뉴 ---------- */
const menuStatusLabel = computed(() => {
  const t = menu.value?.target
  if (!t) return ''
  const item =
    t.kind === 'folder'
      ? folders.value.find((f) => f.idx === t.idx)
      : docs.value.find((d) => d.idx === t.idx)
  return item?.status === 'HIDDEN' ? '공개로 전환' : '숨김으로 전환'
})

function openMenuAt(event: MouseEvent, target: Selection | null) {
  if (target) selected.value = { ...target }
  else selected.value = null
  const menuWidth = 220
  const rows = target ? (canEdit.value ? 6 : 1) : 4
  const menuHeight = rows * 40 + 16
  const pad = 8
  const x = Math.min(event.clientX, window.innerWidth - menuWidth - pad)
  const y = Math.min(event.clientY, window.innerHeight - menuHeight - pad)
  menu.value = { x: Math.max(pad, x), y: Math.max(pad, y), target }
}

function onContextItem(event: MouseEvent, target: Selection) {
  if (!target.idx) return
  openMenuAt(event, target)
}

function onContextBackground(event: MouseEvent) {
  if (!canEdit.value) return
  event.preventDefault()
  openMenuAt(event, null)
}

function closeMenu() {
  menu.value = null
}

function menuOpen() {
  const t = menu.value?.target
  closeMenu()
  if (!t) return
  if (t.kind === 'folder') void onFolderClick(t.idx)
  else {
    const doc = docs.value.find((d) => d.idx === t.idx)
    if (doc) void openDoc(doc)
  }
}

function menuRename() {
  const t = menu.value?.target
  closeMenu()
  if (t) void startRename(t)
}

function menuDelete() {
  const t = menu.value?.target
  closeMenu()
  if (!t) return
  selected.value = { ...t }
  void removeSelected()
}

async function menuEdit() {
  const t = menu.value?.target
  closeMenu()
  if (!t || t.kind !== 'doc') return
  const doc = docs.value.find((d) => d.idx === t.idx)
  if (!doc) return
  await openDoc(doc)
  viewerTab.value = 'edit'
}

async function menuNewSubfolder() {
  const t = menu.value?.target
  closeMenu()
  if (!t || t.kind !== 'folder') return
  await selectFolder(t.idx)
  await beginCreateFolder(t.idx)
}

async function menuToggleStatus() {
  const t = menu.value?.target
  closeMenu()
  if (!t) return
  try {
    if (t.kind === 'folder') {
      const folder = folders.value.find((f) => f.idx === t.idx)
      if (!folder) return
      const status: InfoStatus = folder.status === 'HIDDEN' ? 'PUBLISHED' : 'HIDDEN'
      await saveInfoFolder({ name: folder.name, parentIdx: folder.parentIdx, status, sort: folder.sort }, folder.idx)
    } else {
      const doc = docs.value.find((d) => d.idx === t.idx)
      if (!doc || !doc.idx) return
      const status: InfoStatus = doc.status === 'HIDDEN' ? 'PUBLISHED' : 'HIDDEN'
      let content = doc.content
      if (content == null) {
        const full = await fetchPublicInfoDoc(doc.id)
        content = full.content ?? ''
      }
      await saveInfoDoc(
        { title: doc.title, folderIdx: doc.folderIdx, content, summary: doc.summary, status, sort: doc.sort },
        doc.idx,
      )
    }
    staffNote.value = '공개 상태를 바꿨습니다.'
    await load({ silent: true })
  } catch (error) {
    staffNote.value = error instanceof Error ? error.message : '상태 변경에 실패했습니다.'
  }
}

async function refreshList() {
  closeMenu()
  await load({ silent: true })
  staffNote.value = '목록을 새로고침했습니다.'
}

/* ---------- 키보드 단축키 ---------- */
const flatItems = computed<Selection[]>(() => {
  if (isSearching.value)
    return visibleDocs.value.filter((d) => d.idx).map((d) => ({ kind: 'doc' as const, idx: d.idx as number }))
  return treeRows.value
    .map((r): Selection => (r.kind === 'folder' ? { kind: 'folder', idx: r.idx } : { kind: 'doc', idx: r.doc.idx || 0 }))
    .filter((s) => s.idx)
})

function openSelected() {
  const s = selected.value
  if (!s) return
  if (s.kind === 'folder') void onFolderClick(s.idx)
  else {
    const doc = docs.value.find((d) => d.idx === s.idx)
    if (doc) void openDoc(doc)
  }
}

function goUp() {
  if (isSearching.value || !activeFolder.value) return
  const current = folders.value.find((f) => f.idx === activeFolder.value)
  void selectFolder(current?.parentIdx || 0)
}

function onKeydown(event: KeyboardEvent) {
  if (menu.value) {
    if (event.key === 'Escape') closeMenu()
    return
  }
  if (creatingFolder.value || renaming.value) return
  const tag = (event.target as HTMLElement | null)?.tagName
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return

  if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
    const items = flatItems.value
    if (!items.length) return
    event.preventDefault()
    let i = items.findIndex((it) => it.kind === selected.value?.kind && it.idx === selected.value?.idx)
    if (event.key === 'ArrowDown') i = i < 0 ? 0 : Math.min(items.length - 1, i + 1)
    else i = i < 0 ? items.length - 1 : Math.max(0, i - 1)
    selected.value = { ...items[i] }
    return
  }

  if (event.key === 'Backspace') {
    event.preventDefault()
    goUp()
    return
  }
  if (event.key === 'Escape') {
    selected.value = null
    return
  }
  if (!selected.value) return

  if (event.key === 'Enter') {
    event.preventDefault()
    openSelected()
  } else if (event.key === 'F2' && canEdit.value) {
    event.preventDefault()
    void startRename(selected.value)
  } else if (event.key === 'Delete' && canEdit.value) {
    event.preventDefault()
    void removeSelected()
  }
}

onMounted(async () => {
  await load()
  if (activeFolder.value) {
    expandAncestors(activeFolder.value)
    selected.value = { kind: 'folder', idx: activeFolder.value }
  }
  window.addEventListener('keydown', onKeydown)
  window.addEventListener('resize', closeMenu)
})

onBeforeUnmount(() => {
  window.removeEventListener('keydown', onKeydown)
  window.removeEventListener('resize', closeMenu)
  document.body.classList.remove('fx-is-dragging')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["portal-page info-plaza", { 'info-plaza--dark': _unref(theme) === 'dark' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "info-plaza__head-copy" }, [
          _createElementVNode("h1", null, "정보마당"),
          _createElementVNode("p", null, "왼쪽에서 폴더와 파일을 고르면 내용이 오른쪽에 열립니다.")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          (_unref(isAdminLoggedIn))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: _normalizeClass(["portal-btn info-editmode", editMode.value ? 'portal-btn--primary' : 'portal-btn--secondary']),
                "aria-pressed": editMode.value,
                onClick: toggleEditMode
              }, [
                _createVNode(AppIcon, {
                  icon: editMode.value ? 'mdi-lock-open-variant-outline' : 'mdi-pencil-outline',
                  size: 16
                }, null, 8, ["icon"]),
                _createTextVNode(" " + _toDisplayString(editMode.value ? '변경모드 끄기' : '변경모드'), 1)
              ], 10, _hoisted_4))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "info-theme-toggle",
            "aria-label": _unref(theme) === 'dark' ? '라이트 모드로 보기' : '다크 모드로 보기',
            title: _unref(theme) === 'dark' ? '라이트 모드' : '다크 모드',
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggleTheme) && _unref(toggleTheme)(...args)))
          }, [
            _createVNode(AppIcon, {
              icon: _unref(theme) === 'dark' ? 'mdi-weather-sunny' : 'mdi-weather-night',
              size: 18
            }, null, 8, ["icon"])
          ], 8, _hoisted_5)
        ])
      ]),
      (staffNote.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(staffNote.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("aside", {
          class: _normalizeClass(["info-plaza__side", { 'is-drop': dropTarget.value === 'root' }]),
          "aria-label": "정보마당 폴더",
          onDragover: _cache[11] || (_cache[11] = ($event: any) => (onDragOverTarget('root', $event))),
          onDragleave: _cache[12] || (_cache[12] = ($event: any) => (onDragLeaveTarget('root'))),
          onDrop: _cache[13] || (_cache[13] = ($event: any) => (onDropTarget('root')))
        }, [
          (canEdit.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("button", {
                  type: "button",
                  class: "portal-btn portal-btn--secondary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (beginCreateFolder()))
                }, "새 폴더"),
                _createElementVNode("button", {
                  type: "button",
                  class: "portal-btn portal-btn--primary",
                  onClick: triggerUpload
                }, "HTML 업로드"),
                _createElementVNode("input", {
                  ref_key: "uploadInput",
                  ref: uploadInput,
                  type: "file",
                  accept: ".html,.htm,text/html",
                  multiple: "",
                  hidden: "",
                  onChange: onUploadChange
                }, null, 544)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            class: "info-plaza__search",
            role: "search",
            onSubmit: _withModifiers(runSearch, ["prevent"])
          }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((keyword).value = $event)),
              type: "search",
              class: "portal-input",
              placeholder: "제목·내용 검색",
              "aria-label": "정보마당 검색"
            }, null, 512), [
              [
                _vModelText,
                keyword.value,
                void 0,
                { trim: true }
              ]
            ]),
            _createElementVNode("button", _hoisted_9, [
              _createVNode(AppIcon, {
                icon: "mdi-magnify",
                size: 18
              })
            ])
          ], 32),
          _createElementVNode("div", {
            class: "info-plaza__tree",
            onContextmenu: onContextBackground
          }, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, "불러오는 중…"))
              : (errorMessage.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(errorMessage.value), 1))
                : (isSearching.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "info-tree__item info-tree__item--root",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (selectFolder(0)))
                      }, [
                        _createVNode(AppIcon, {
                          icon: "mdi-arrow-left",
                          size: 16
                        }),
                        _createElementVNode("span", _hoisted_12, "'" + _toDisplayString(appliedKeyword.value) + "' 검색 " + _toDisplayString(visibleDocs.value.length) + "건", 1)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleDocs.value, (doc) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `s-${doc.id}`,
                          class: "info-tree__row",
                          style: {"--depth":"1"}
                        }, [
                          _cache[25] || (_cache[25] = _createElementVNode("span", { class: "info-tree__toggle-spacer" }, null, -1)),
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["info-tree__item info-tree__item--doc", { 'is-on': viewer.value?.id === doc.id, 'is-hidden': doc.status === 'HIDDEN' }]),
                            onClick: ($event: any) => (openDoc(doc))
                          }, [
                            _cache[24] || (_cache[24] = _createElementVNode("svg", {
                              viewBox: "0 0 24 24",
                              "aria-hidden": "true",
                              class: "info-tree__svg info-tree__svg--doc"
                            }, [
                              _createElementVNode("path", {
                                d: "M6 2.5h7.5L19 8v13.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 21.5v-17A1.5 1.5 0 0 1 6 2.5Z",
                                class: "info-doc__svg-body"
                              }),
                              _createElementVNode("path", {
                                d: "M13.5 2.5V8H19L13.5 2.5Z",
                                class: "info-doc__svg-fold"
                              })
                            ], -1)),
                            _createElementVNode("span", _hoisted_14, _toDisplayString(doc.title), 1),
                            (doc.folderName)
                              ? (_openBlock(), _createElementBlock("em", _hoisted_15, _toDisplayString(doc.folderName), 1))
                              : _createCommentVNode("", true)
                          ], 10, _hoisted_13)
                        ]))
                      }), 128)),
                      (!visibleDocs.value.length)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_16, "검색 결과가 없습니다."))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["info-tree__item info-tree__item--root", { 'is-on': !selected.value && !viewer.value }]),
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (selectFolder(0)))
                      }, [
                        _cache[26] || (_cache[26] = _createElementVNode("svg", {
                          viewBox: "0 0 24 24",
                          "aria-hidden": "true",
                          class: "info-tree__home"
                        }, [
                          _createElementVNode("path", {
                            d: "M4 11.2 12 4l8 7.2V20h-5.4v-5.6H9.4V20H4v-8.8Z",
                            fill: "currentColor"
                          })
                        ], -1)),
                        _cache[27] || (_cache[27] = _createElementVNode("span", { class: "info-tree__name" }, "전체", -1)),
                        _createElementVNode("em", null, _toDisplayString(docs.value.length), 1)
                      ], 2),
                      (creatingFolder.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _cache[29] || (_cache[29] = _createElementVNode("span", { class: "info-tree__toggle-spacer" }, null, -1)),
                            _createElementVNode("span", _hoisted_18, [
                              _cache[28] || (_cache[28] = _createElementVNode("svg", {
                                viewBox: "0 0 48 48",
                                "aria-hidden": "true",
                                class: "info-tree__svg"
                              }, [
                                _createElementVNode("path", {
                                  d: "M6 13a5 5 0 0 1 5-5h8.6l4.2 5.4H37a5 5 0 0 1 5 5v2H6v-7.4Z",
                                  class: "info-folder__svg-back"
                                }),
                                _createElementVNode("path", {
                                  d: "M6 19h36v13a5 5 0 0 1-5 5H11a5 5 0 0 1-5-5V19Z",
                                  class: "info-folder__svg-front"
                                })
                              ], -1)),
                              _withDirectives(_createElementVNode("input", {
                                ref_key: "newFolderBox",
                                ref: newFolderBox,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newFolderName).value = $event)),
                                class: "fx-rename",
                                placeholder: "새 폴더",
                                "aria-label": "새 폴더 이름",
                                onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
                                onKeyup: [
                                  _withKeys(commitCreateFolder, ["enter"]),
                                  _withKeys(cancelCreateFolder, ["esc"])
                                ],
                                onBlur: commitCreateFolder
                              }, null, 544), [
                                [
                                  _vModelText,
                                  newFolderName.value,
                                  void 0,
                                  { trim: true }
                                ]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(treeRows.value, (row) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: row.kind === 'folder' ? `f-${row.idx}` : `d-${row.doc.id}`
                        }, [
                          (row.kind === 'folder')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["info-tree__row", {
                    'is-drop': dropTarget.value === row.idx,
                    'is-dragging': dragInfo.value?.kind === 'folder' && dragInfo.value.idx === row.idx,
                  }]),
                                style: _normalizeStyle({ '--depth': row.depth }),
                                draggable: canEdit.value && !isRenamingId('folder', row.idx),
                                onDragstart: ($event: any) => (onDragStart('folder', row.idx, $event)),
                                onDragend: onDragEnd,
                                onDragover: ($event: any) => (onDragOverTarget(row.idx, $event)),
                                onDragleave: ($event: any) => (onDragLeaveTarget(row.idx)),
                                onDrop: ($event: any) => (onDropTarget(row.idx)),
                                onContextmenu: _withModifiers(($event: any) => (onContextItem($event, { kind: 'folder', idx: row.idx })), ["prevent","stop"])
                              }, [
                                (row.hasChildren)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: _normalizeClass(["info-tree__toggle", { 'is-open': expanded.value.has(row.idx) }]),
                                      "aria-label": expanded.value.has(row.idx) ? `${row.name} 접기` : `${row.name} 펼치기`,
                                      onClick: _withModifiers(($event: any) => (toggleFolder(row.idx)), ["stop"])
                                    }, [...(_cache[30] || (_cache[30] = [
                                      _createElementVNode("svg", {
                                        viewBox: "0 0 24 24",
                                        "aria-hidden": "true"
                                      }, [
                                        _createElementVNode("path", {
                                          d: "m9 5 7 7-7 7",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2.4",
                                          "stroke-linecap": "round"
                                        })
                                      ], -1)
                                    ]))], 10, _hoisted_20))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_21)),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: _normalizeClass(["info-tree__item", { 'is-on': selected.value?.kind === 'folder' && selected.value.idx === row.idx, 'is-hidden': row.status === 'HIDDEN' }]),
                                  onClick: ($event: any) => (onFolderClick(row.idx))
                                }, [
                                  _cache[31] || (_cache[31] = _createElementVNode("svg", {
                                    viewBox: "0 0 48 48",
                                    "aria-hidden": "true",
                                    class: "info-tree__svg"
                                  }, [
                                    _createElementVNode("path", {
                                      d: "M6 13a5 5 0 0 1 5-5h8.6l4.2 5.4H37a5 5 0 0 1 5 5v2H6v-7.4Z",
                                      class: "info-folder__svg-back"
                                    }),
                                    _createElementVNode("path", {
                                      d: "M6 19h36v13a5 5 0 0 1-5 5H11a5 5 0 0 1-5-5V19Z",
                                      class: "info-folder__svg-front"
                                    })
                                  ], -1)),
                                  (isRenamingId('folder', row.idx))
                                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 0,
                                        ref_for: true,
                                        ref_key: "renameBox",
                                        ref: renameBox,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((renameText).value = $event)),
                                        class: "fx-rename",
                                        onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
                                        onKeyup: [
                                          _withKeys(commitRename, ["enter"]),
                                          _withKeys(cancelRename, ["esc"])
                                        ],
                                        onBlur: commitRename
                                      }, null, 544)), [
                                        [
                                          _vModelText,
                                          renameText.value,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ])
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("span", _hoisted_23, [
                                          _createTextVNode(_toDisplayString(row.name) + " ", 1),
                                          (row.status === 'HIDDEN')
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_24, "숨김"))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("em", null, _toDisplayString(row.count), 1)
                                      ], 64))
                                ], 10, _hoisted_22)
                              ], 46, _hoisted_19))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(["info-tree__row", { 'is-dragging': dragInfo.value?.kind === 'doc' && dragInfo.value.idx === row.doc.idx }]),
                                style: _normalizeStyle({ '--depth': row.depth }),
                                draggable: canEdit.value && !!row.doc.idx && !isRenamingId('doc', row.doc.idx || 0),
                                onDragstart: ($event: any) => (onDragStart('doc', row.doc.idx || 0, $event)),
                                onDragend: onDragEnd,
                                onContextmenu: _withModifiers(($event: any) => (onContextItem($event, { kind: 'doc', idx: row.doc.idx || 0 })), ["prevent","stop"])
                              }, [
                                _cache[33] || (_cache[33] = _createElementVNode("span", { class: "info-tree__toggle-spacer" }, null, -1)),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: _normalizeClass(["info-tree__item info-tree__item--doc", { 'is-on': viewer.value?.id === row.doc.id, 'is-hidden': row.doc.status === 'HIDDEN' }]),
                                  onClick: ($event: any) => (openDoc(row.doc))
                                }, [
                                  _cache[32] || (_cache[32] = _createElementVNode("svg", {
                                    viewBox: "0 0 24 24",
                                    "aria-hidden": "true",
                                    class: "info-tree__svg info-tree__svg--doc"
                                  }, [
                                    _createElementVNode("path", {
                                      d: "M6 2.5h7.5L19 8v13.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 21.5v-17A1.5 1.5 0 0 1 6 2.5Z",
                                      class: "info-doc__svg-body"
                                    }),
                                    _createElementVNode("path", {
                                      d: "M13.5 2.5V8H19L13.5 2.5Z",
                                      class: "info-doc__svg-fold"
                                    }),
                                    _createElementVNode("path", {
                                      d: "M8.5 12.5h7M8.5 15.5h7M8.5 18.5h4.5",
                                      class: "info-doc__svg-lines"
                                    })
                                  ], -1)),
                                  (isRenamingId('doc', row.doc.idx || 0))
                                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 0,
                                        ref_for: true,
                                        ref_key: "renameBox",
                                        ref: renameBox,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((renameText).value = $event)),
                                        class: "fx-rename",
                                        onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
                                        onKeyup: [
                                          _withKeys(commitRename, ["enter"]),
                                          _withKeys(cancelRename, ["esc"])
                                        ],
                                        onBlur: commitRename
                                      }, null, 544)), [
                                        [
                                          _vModelText,
                                          renameText.value,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ])
                                    : (_openBlock(), _createElementBlock("span", _hoisted_27, [
                                        _createTextVNode(_toDisplayString(row.doc.title) + " ", 1),
                                        (row.doc.status === 'HIDDEN')
                                          ? (_openBlock(), _createElementBlock("i", _hoisted_28, "숨김"))
                                          : _createCommentVNode("", true)
                                      ]))
                                ], 10, _hoisted_26)
                              ], 46, _hoisted_25))
                        ], 64))
                      }), 128)),
                      (!treeRows.value.length && !creatingFolder.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_29, "폴더가 없습니다."))
                        : _createCommentVNode("", true)
                    ], 64))
          ], 32),
          (canEdit.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_30, [...(_cache[34] || (_cache[34] = [
                _createTextVNode(" 끌어 옮기기 · 우클릭 메뉴 · ", -1),
                _createElementVNode("kbd", null, "F2", -1),
                _createTextVNode(" 이름변경 · ", -1),
                _createElementVNode("kbd", null, "Del", -1),
                _createTextVNode(" 삭제 ", -1)
              ]))]))
            : (_unref(isAdminLoggedIn))
              ? (_openBlock(), _createElementBlock("p", _hoisted_31, "편집하려면 우측 상단 「변경모드」를 켜세요."))
              : _createCommentVNode("", true)
        ], 34),
        _createElementVNode("main", _hoisted_32, [
          (viewer.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("header", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("h2", null, _toDisplayString(viewer.value.title), 1),
                    (viewer.value.folderName)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(viewer.value.folderName), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (canEdit.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createElementVNode("button", {
                          type: "button",
                          role: "tab",
                          "aria-selected": viewerTab.value === 'view',
                          class: _normalizeClass({ 'is-on': viewerTab.value === 'view' }),
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (viewerTab.value = 'view'))
                        }, " 보기 ", 10, _hoisted_37),
                        _createElementVNode("button", {
                          type: "button",
                          role: "tab",
                          "aria-selected": viewerTab.value === 'edit',
                          class: _normalizeClass({ 'is-on': viewerTab.value === 'edit' }),
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (viewerTab.value = 'edit'))
                        }, " HTML 편집 ", 10, _hoisted_38)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _withDirectives(_createElementVNode("iframe", {
                    class: "info-reader__frame",
                    srcdoc: frameSrcdoc(viewer.value.content || ''),
                    sandbox: "",
                    title: `${viewer.value.title} 내용`,
                    referrerpolicy: "no-referrer"
                  }, null, 8, _hoisted_40), [
                    [_vShow, viewerTab.value === 'view']
                  ]),
                  (viewerTab.value === 'edit')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("label", _hoisted_42, [
                          _cache[35] || (_cache[35] = _createElementVNode("span", null, "제목", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((editDraft.value.title) = $event)),
                            type: "text",
                            class: "portal-input"
                          }, null, 512), [
                            [
                              _vModelText,
                              editDraft.value.title,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_43, [
                          _cache[36] || (_cache[36] = _createElementVNode("span", null, "HTML", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((editDraft.value.content) = $event)),
                            spellcheck: "false"
                          }, null, 512), [
                            [_vModelText, editDraft.value.content]
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_44, [
                          _cache[38] || (_cache[38] = _createElementVNode("span", null, "공개", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((editDraft.value.status) = $event)),
                            class: "portal-input"
                          }, [...(_cache[37] || (_cache[37] = [
                            _createElementVNode("option", { value: "PUBLISHED" }, "공개", -1),
                            _createElementVNode("option", { value: "HIDDEN" }, "숨김", -1)
                          ]))], 512), [
                            [_vModelSelect, editDraft.value.status]
                          ])
                        ]),
                        (editError.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(editError.value), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (canEdit.value && viewerTab.value === 'edit')
                  ? (_openBlock(), _createElementBlock("footer", _hoisted_46, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "portal-btn portal-btn--secondary",
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (viewerTab.value = 'view'))
                      }, "취소"),
                      _createElementVNode("button", {
                        type: "button",
                        class: "portal-btn portal-btn--primary",
                        disabled: savingEdit.value,
                        onClick: saveEdit
                      }, _toDisplayString(savingEdit.value ? '저장 중…' : '저장'), 9, _hoisted_47)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock("section", {
                key: 1,
                class: "info-cards",
                "aria-label": `${gridTitle.value} 글 목록`
              }, [
                _createElementVNode("header", _hoisted_49, [
                  _createElementVNode("h2", null, _toDisplayString(gridTitle.value), 1),
                  _createElementVNode("span", null, _toDisplayString(gridDocs.value.length) + "개", 1)
                ]),
                (gridDocs.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gridDocs.value, (doc) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: doc.id,
                          type: "button",
                          class: _normalizeClass(["info-card", { 'is-hidden': doc.status === 'HIDDEN' }]),
                          onClick: ($event: any) => (openDoc(doc))
                        }, [
                          _createElementVNode("span", _hoisted_52, [
                            (thumbImage(doc))
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: thumbImage(doc),
                                  alt: ""
                                }, null, 8, _hoisted_53))
                              : (htmlOf(doc))
                                ? (_openBlock(), _createElementBlock("iframe", {
                                    key: 1,
                                    class: "info-card__frame",
                                    srcdoc: frameSrcdoc(htmlOf(doc)),
                                    sandbox: "",
                                    tabindex: "-1",
                                    title: ""
                                  }, null, 8, _hoisted_54))
                                : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("span", _hoisted_55, [
                            _createElementVNode("em", null, _toDisplayString(doc.folderName || '정보마당'), 1),
                            _createElementVNode("time", null, _toDisplayString(doc.updatedAt || doc.createdAt), 1)
                          ]),
                          _createElementVNode("strong", _hoisted_56, _toDisplayString(doc.title), 1),
                          (doc.summary)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(doc.summary), 1))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_51))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_58, "이 폴더에는 글이 없습니다."))
              ], 8, _hoisted_48))
        ])
      ]),
      (menu.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", {
              class: "fx-menu__veil",
              onClick: closeMenu,
              onContextmenu: _withModifiers(closeMenu, ["prevent"])
            }, null, 32),
            _createElementVNode("ul", {
              class: "fx-menu",
              style: _normalizeStyle({ top: `${menu.value.y}px`, left: `${menu.value.x}px` }),
              role: "menu",
              onClick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"])),
              onContextmenu: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["prevent","stop"]))
            }, [
              (menu.value.target)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("li", _hoisted_59, [
                      _createElementVNode("button", {
                        type: "button",
                        role: "menuitem",
                        onClick: menuOpen
                      }, _toDisplayString(menu.value.target.kind === 'folder' ? '열기' : '보기'), 1)
                    ]),
                    (canEdit.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (menu.value.target.kind === 'doc')
                            ? (_openBlock(), _createElementBlock("li", _hoisted_60, [
                                _createElementVNode("button", {
                                  type: "button",
                                  role: "menuitem",
                                  onClick: menuEdit
                                }, "HTML 편집")
                              ]))
                            : _createCommentVNode("", true),
                          _cache[41] || (_cache[41] = _createElementVNode("li", {
                            class: "fx-menu__sep",
                            role: "separator"
                          }, null, -1)),
                          _createElementVNode("li", { role: "none" }, [
                            _createElementVNode("button", {
                              type: "button",
                              role: "menuitem",
                              onClick: menuRename
                            }, [...(_cache[39] || (_cache[39] = [
                              _createTextVNode("이름 변경 ", -1),
                              _createElementVNode("kbd", null, "F2", -1)
                            ]))])
                          ]),
                          _createElementVNode("li", _hoisted_61, [
                            _createElementVNode("button", {
                              type: "button",
                              role: "menuitem",
                              onClick: menuToggleStatus
                            }, _toDisplayString(menuStatusLabel.value), 1)
                          ]),
                          (menu.value.target.kind === 'folder')
                            ? (_openBlock(), _createElementBlock("li", _hoisted_62, [
                                _createElementVNode("button", {
                                  type: "button",
                                  role: "menuitem",
                                  onClick: menuNewSubfolder
                                }, "새 하위 폴더")
                              ]))
                            : _createCommentVNode("", true),
                          _cache[42] || (_cache[42] = _createElementVNode("li", {
                            class: "fx-menu__sep",
                            role: "separator"
                          }, null, -1)),
                          _createElementVNode("li", { role: "none" }, [
                            _createElementVNode("button", {
                              type: "button",
                              role: "menuitem",
                              class: "is-danger",
                              onClick: menuDelete
                            }, [...(_cache[40] || (_cache[40] = [
                              _createTextVNode("삭제 ", -1),
                              _createElementVNode("kbd", null, "Del", -1)
                            ]))])
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                : (canEdit.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("li", _hoisted_63, [
                        _createElementVNode("button", {
                          type: "button",
                          role: "menuitem",
                          onClick: _cache[20] || (_cache[20] = ($event: any) => (beginCreateFolder()))
                        }, "새 폴더")
                      ]),
                      _createElementVNode("li", { role: "none" }, [
                        _createElementVNode("button", {
                          type: "button",
                          role: "menuitem",
                          onClick: triggerUpload
                        }, "HTML 업로드")
                      ]),
                      _cache[43] || (_cache[43] = _createElementVNode("li", {
                        class: "fx-menu__sep",
                        role: "separator"
                      }, null, -1)),
                      _createElementVNode("li", { role: "none" }, [
                        _createElementVNode("button", {
                          type: "button",
                          role: "menuitem",
                          onClick: refreshList
                        }, "새로고침")
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
            ], 36)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})